export class OrderDetailModel {
    BettingId: number;
    BettingID: number;
    UserName: string;
    LotteryName: string;
    PlayName: string;
    SelectMedian: string;
    IssueNo: string;
    BettingMoney: number;
    StateName: string;
    GraduationCount: number;
    Reward: number;
    BonusMoney: number;
    IsChaseNo: boolean;
    BuyIssueCount: number;
    CompleteIssueCount: number;
    IsStopAfterWinning: boolean;
    AddTime: string;
    RevocationMoney: number;
    BettingNumber: string;
    LotteryCode: string;
    LotteryTypeCode: string;
    Issues:BettingInfoIssue[];
    BettingInfoIssues: BettingInfoIssue[];
    BettingItems: DollarsBetting[];
    PlayCode: string;
    LotteryPlayModeCode: string;
    LotteryPlayModeName: string;
    LotteryPlayModeTypeCode: number;
    BettingItemCount: number;
}

export class BettingInfoIssue {
    BettingId: number;
    IssueNo: string;
    Multiple: number;
    PerPrice: number;
    BettingMoney: number;
    Reward: number;
    BonusMoney: number;
    WinningCount: number;
    State: string;
    StateName: string;
    AddTime: string;
    LotteryCode: string;
    OpenNo: string;
    ID: number;
    BettingInfoIssueID: number;
    BettingItems: string;
}

export class DollarsBetting {
    BettingId: number;
    BettingMoney: number;
    BettingNumber: string;
    LotteryPlayDetailCode: string;
    Position: any;
    Rebate: number;
    SerialNo: number;
}


// WEBPACK FOOTER //
// ./src/models/orderdetail.model.ts